module.exports = __webpack_public_path__ + "img/preview-14.2faa0187.png";